import { Button, Tooltip } from "@mui/material"
import { Restore } from "@mui/icons-material"

const ResetDefaultButton = ({ options }) => {
  const { handleResetGrid } = options

  return (
    <Tooltip placement="top" title="Reset to default columns">
      <Button color="primary" variant="text" onClick={handleResetGrid} startIcon={<Restore />}>
        Reset
      </Button>
    </Tooltip>
  )
}

export default ResetDefaultButton
